<template>
  <!-- 2020-02-26 CCTV 재생시에만 Wowza에 연결되도록 함에 따라 로딩 시간, 로딩 화면 추가 -->
  <div class="pcs">
    <section class="my_page_area">
      <div class="title_area">
        <span class="title">CCTV 목록</span>
        <span @click="clickList('play')">
          <img
            src="../../../assets/image/mobile/play.png"
            style="float:right; width:28px; height:26px; margin-top:9px"
          >
        </span>
        <span @click="clickList('thumbnail')">
          <img src="../../../assets/image/mobile/list.png" style="float:right; margin-top:9px;">
        </span>
      </div>
      <!-- 2020-03-26 - 로딩화면 원형대신 퍼센트 막대바로 변경 -->
      <div id="loadingBar" v-show="loading">
        <!-- <div id="loadingBar"></div> -->
      </div>
      <!-- 로딩이 끝나야 렌더링, 미리 렌더링하면 로딩시간이 오히려 더 걸림 - 2020-03-03 김진희 -->
      <div class="info_result_frame" v-show="!loading & thumbnailList">
        <div class="site_admin_frame">
          <div class="result_area">
            <div
              class="reuslt_box"
              v-for="(cctvList, index) in cctvList"
              :key="cctvList.cctv"
              @click="cctvConnectPlay(cctvList.site_id, index)"
            >
              <div class="top_area">
                <span class="img">
                  <img :id="'listImg' + index" style="margin-top: -2vw;">
                </span>

                <span class="title" style="margin-left: 90px;">
                  &middot;
                  <!-- {{description}} - CCTV {{index+1}}번 -->
                  {{description}}
                </span>
              </div>
              <div class="bottom_area">
                <span class="txt"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 로딩이 끝나야 렌더링 - 2020-03-03 김진희 -->
      <div class="info_result_frame1" v-show="!loading && playList">
        <div class="two_thumbnails" style="display:flex; margin-top:5px;">
          <img
            style="margin-left:5px;"
            v-for="(cctv1, idx) in cctv1"
            :id="'playImg' + idx"
            :key="cctv1.cctv"
            @click="cctvConnectPlay(cctv1.site_id, idx)"
          >
        </div>
        <div class="two_thumbnails" style="display:flex; margin-top:5px;">
          <img
            style="margin-left:5px;"
            v-for="(cctv2, idx) in cctv2"
            :id="'playImg' + (idx+2)"
            :key="cctv2.cctv"
            @click="cctvConnectPlay(cctv2.site_id, idx)"
          >
        </div>
        <!-- <div style="display:flex;">
          <img
            v-for="(cctv3, idx) in cctv3"
            :key="cctv3.cctv"
            :src="'http://211.193.192.204:1935/thumbnail?application=live&streamname='+cctv3.site_id+'_'+(idx+1)+'.stream&size='+cctv3.width+'x'+cctv3.heigth+'&format=png'"
            @click="cctvConnectPlay(cctv3.site_id+'_'+(idx+1))"
            @load="imgRefresh($event, 7000)"
          >
        </div>-->
      </div>
      <!-- 2020-04-17 CctvPlayer 로딩 화면 -->
      <PlayerLoadingOverlay
        :active.sync="playerLoadingScreen"
        :can-cancel="true"
        :on-cancel="cancelCctvPlay"
        :is-full-page="true"
      ></PlayerLoadingOverlay>
    </section>
  </div>
</template>

<script>
import { getSiteEssDetail } from '@/api/master/master'
import envs from '@/envs'
import localStore from '@/utils/localStore'
import {
  connect,
  disconnect,
  connectAll,
  disconnectAll,
  captureFrameFromHLS
} from '@/api/cctv/cctvConnector'
import Vue from 'vue'
import PlayerLoadingOverlay from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import { debugMessage } from '@/utils/debugMessage'

Vue.use(PlayerLoadingOverlay)

// 5초 즈음에 로딩 여부를 체크함
const LOADING_CHECK_TIME = 2 // 초 단위
const THUMBNAIL_SHOW_TIME_MARGIN = 3
const LOADING_GAGE_TIME_MARGIN = 7
const LOADING_GAGE_TIME =
  LOADING_CHECK_TIME + THUMBNAIL_SHOW_TIME_MARGIN + LOADING_GAGE_TIME_MARGIN // 초 단위
const RETRY_TIME = 1

const LIMIT_MINUTE = 20

// 다음은 로딩화면 원 그림에 대한 설정
// 4번만 바뀌게 하는 것이 보기 좋은 듯
// const LOADING_TIME_DIVISION = 6 // 반드시 정수
const LOADING_TIME_DIVISION = LOADING_GAGE_TIME + 1 // 반드시 정수
// 그림이 변하는 간격
const LOADING_TIME_INTERVAL = LOADING_GAGE_TIME / LOADING_TIME_DIVISION
var loadingStartTime = LOADING_TIME_INTERVAL // 그림 변하는 시간 고려해서 한 스텝 앞서게 함
var loadingTime = loadingStartTime

export default {
  data() {
    return {
      site_id: '',
      cctvList: [],
      admin: false,
      WowzaAddress: envs.WowzaAddress,
      updatePeriod: 10000,
      description: '',
      loading: true,
      // 각 cctv의 세로 리스트, 가로 리스트에 대한 썸네일 로드 여부 기록
      thumbnailLoaded: [
        [false, false],
        [false, false],
        [false, false],
        [false, false]
      ],
      loadCompleted: false,
      thumbnailList: true,
      playList: false,
      player: [],
      cctv1: [],
      cctv2: [],
      cctv3: [],
      // 색상
      loadingCircleColor: { gradient: ['red', 'green', 'blue'] },
      limitMinute: 20,
      playerLoadingScreen: false, // CCTV 선택 시 로딩화면 표시
      loadingCctvId: '', // CCTV 로딩 중 취소 시 연결 해제를 위한 정보
      // CCTV 창이 닫혔을 때 스트리밍 종료하거나,
      // 다른 CCTV 창 열 때 하나의 CCTV 창만 허용하도록
      // 기존의 창을 닫기 위한 정보
      openedCctvPopup: null,
      popupOpened: false
    }
  },
  components: {
    // VueCircle
    PlayerLoadingOverlay
  },
  beforeCreate: function() {},
  beforeDestroy: function() {
    // console.log('before disconnectAll')
    disconnectAll()
    if (this.openedCctvPopup !== null) {
      this.openedCctvPopup.close()
    }
    // console.log('after disconnectAll')
  },
  created: function() {
    if (this.$router.history.current.query.site_id !== undefined) {
      this.site_id = this.$router.history.current.query.site_id
    }
  },
  mounted: function() {
    this.init_data()
    this.waitForLoading()

    // 안드로이드앱에서만 썸네일이 적용되지않는 현상이 생겨서 추가 2019-10-31
    if (
      localStore.get('userId') === 'hadmin' &&
      navigator.userAgent.toLocaleLowerCase().indexOf('android') > -1
    ) {
      this.admin = true
    }

    // 하단 CSS 적용 안 되서 이렇게 함
    $('.el-footer').css('position', 'fixed')
    $('.el-footer').css('bottom', '0px')

    // 20분 지나면 자동으로 뒤로 돌아감
    setTimeout(() => {
      disconnectAll()
      // 바로 종료시키면 제대로 반영 안 되므로 시간차를 둠
      setTimeout(() => {
        history.back()
      }, 2000)
    }, LIMIT_MINUTE * 60 * 1000)
  },
  updated: function() {},
  methods: {
    init_data() {
      if (this.site_id !== undefined && this.site_id !== '') {
        let params = {
          codenm: this.site_id
        }
        var tempList = []

        getSiteEssDetail(params).then(response => {
          this.description = response.siteDec[0].description
          var cctvInfo = response.siteDec[0]

          if (cctvInfo.cctv_stat) {
            if (
              cctvInfo.cctv_stat.indexOf('NR_') > -1 ||
              cctvInfo.cctv_stat.indexOf('DR_') > -1
            ) {
              for (var i = 0; i < cctvInfo.cctv_cnt; i++) {
                var cctv = {
                  cctv: this.site_id + '_' + (i + 1),
                  site_id: this.site_id,
                  cnt: cctvInfo.cctv_cnt
                }
                tempList.push(cctv)
              }
            } else if (cctvInfo.cctv_stat.indexOf('CC_') > -1) {
              var cnt = 0
              var siteId = this.site_id
              $.each(cctvInfo, function(key, value) {
                if (key.indexOf('cctv') > -1 && value) {
                  if (key.indexOf('cctv_') < 0) {
                    cnt++
                    var cctv = {
                      cctv: siteId + '_' + cnt,
                      site_id: siteId,
                      cnt: cctvInfo.cctv_cnt
                    }
                    tempList.push(cctv)
                  }
                }
              })
            }
            this.cctvList = tempList

            connectAll(this.site_id, this.cctvList.length)

            // //플레이어 동적 html
            let playerCnt = this.cctvList[0].cnt
            let playerWidth = window.innerWidth // 플레이어width
            let playerHeight = window.innerHeight / 2 // 플레이어height
            let playerDivArea = playerCnt < 5 ? [2, 7] : [3, 6]

            // CCTV 개수에 따라 크기 결정(최대 9개까지만)
            playerHeight =
              playerCnt > 1
                ? playerCnt < 7
                  ? playerHeight / 2
                  : playerHeight / 3
                : playerHeight
            playerWidth =
              playerCnt > 1
                ? playerCnt < 5
                  ? playerWidth / 2
                  : playerWidth / 3
                : playerWidth

            for (let idx = 0; idx < playerCnt; idx++) {
              this.cctvList[idx].width = playerWidth
              this.cctvList[idx].height = playerHeight
              // CCTV 화면분할(최대 9개까지만)
              if (idx < playerDivArea[0]) {
                this.cctv1.push(this.cctvList[idx])
              } else {
                if (idx < playerDivArea[1]) {
                  this.cctv2.push(this.cctvList[idx])
                } else {
                  this.cctv3.push(this.cctvList[idx])
                }
              }
            }
          }
        })
      }
    },
    loadThumbnails() {
      this.cctvList.forEach((cctvInfo, cctvIndex) => {
        captureFrameFromHLS(cctvInfo.cctv).then(dataUrl => {
          if (!dataUrl) return
          ;['listImg', 'playImg'].forEach((prefix, elementIndex) => {
            const thumbnail = document.getElementById(prefix + cctvIndex)
            if (thumbnail) {
              thumbnail.src = dataUrl
              thumbnail.style.display = 'block'
              this.thumbnailLoaded[cctvIndex][elementIndex] = true
            }
          })
          if (this.thumbnailLoaded.every(pair => pair.every(v => v))) {
            this.loadCompleted = true
            setTimeout(() => {
              this.loading = false
              loadingTime = 0
            }, THUMBNAIL_SHOW_TIME_MARGIN * 1000)
          }
        })
      })
    },
    updateThumbnailPeriodically(img, updatePeriod) {
      setTimeout(
        function() {
          // let img = document.getElementById(img)
          let date = new Date()
          let http = img.src

          date.setTime(date.getTime() - 10000)
          if (http.indexOf('&d=') > -1) http = http.split('&d=')[0]
          img.src = http + '&d=' + date.getTime()
          console.log('썸네일 업데이트 주기: ' + updatePeriod)
          this.updateThumbnailPeriodically(img, updatePeriod)
        }.bind(this),
        updatePeriod
      )
    },
    // 2020-07-22 cctvConnectPlay 메서드는 껍데기만 남김
    cctvConnectPlay(siteId, index) {
      // let cctvId = siteId + '_' + (index + 1)
      // console.log(cctvId)

      // if (this.openedCctvPopup !== null) {
      //   this.openedCctvPopup.close()
      //   disconnect(this.streamingCctvId)
      //   this.openedCctvPopup = null
      // }

      this.playerLoadingScreen = true
      // this.streamingCctvId = cctvId

      // connect(cctvId)
      this.cctvPlay(siteId, index)
    },
    cctvPlay(siteId, index) {
      let cctvId = siteId + '_' + (index + 1)
      let url = envs.WowzaAddress + '/live/' + cctvId + '.stream/playlist.m3u8'

      axios
        .get(url, {
          params: {}
        })
        .then(
          function(response) {
            var strWindowFeatures =
              'menubar=no,location=no,scrollbars=no,toolbar=no'

            this.playerLoadingScreen = false
            if (
              // location.href.indexOf('div=android') > -1 ||
              location.href.indexOf('div=ios') > -1
            ) {
              this.openedCctvPopup = window.open(
                url,
                '_self',
                strWindowFeatures
              )
            } else {
              this.openedCctvPopup = window.open(url, 'null', strWindowFeatures)
            }

            // 2020-07-22 - 팝업 창 종료 시 연결해제 안 함 (재생 로딩시간 방지)
            // if (
            //   location.href.indexOf('div=android') > -1 ||
            //   location.href.indexOf('div=ios') > -1
            // ) {
            //   debugMessage('코르도바에서 팝업창 열기')
            //   // 이 경우 this.openedCctvPopup 은 cordova.InAppBrowser 객체가 된다.
            //   this.openedCctvPopup.addEventListener('exit', () => {
            //     // 코르도바 앱에서 종료한 경우
            //     debugMessage('코르도바에서 ' + `disconnect(${cctvId})`)
            //     // connect한 곳과 다른 창에서 처리하므로 siteId와 count를 제공해야함
            //     disconnect(cctvId)
            //   })
            // } else {
            //   debugMessage('브라우저에서 팝업창 열기')
            //   this.checkPopupClosedDisconnect(
            //     this.openedCctvPopup,
            //     siteId,
            //     index
            //   )
            // }
          }.bind(this)
        )
        .catch(
          function(error) {
            if (this.playerLoadingScreen) {
              setTimeout(() => {
                let cctvId = siteId + '_' + (index + 1)
                connect(cctvId)
                this.cctvPlay(siteId, index)
              }, RETRY_TIME * 1000)
            }
            // console.log('실패')
            console.log(error)
          }.bind(this)
        )
        .finally(function() {})
    },
    checkPopupClosedDisconnect(popupWindow, siteId, index) {
      let cctvId = siteId + '_' + (index + 1)

      setTimeout(() => {
        if (popupWindow === null || popupWindow.parent === null) {
          debugMessage(`disconnect(${cctvId})`)
          // connect한 곳과 다른 창에서 처리하므로 siteId와 count를 제공해야함
          disconnect(cctvId)
        } else {
          debugMessage('1초 후 다시 확인')
          // secretDebugMessage('popupWindow 변수 내용')
          // secretDebugMessage(popupWindow) // 이 내용을 실사용시 출력하면 오류남
          this.checkPopupClosedDisconnect(popupWindow, siteId, index)
        }
      }, 1000)
    },
    cancelCctvPlay() {
      this.playerLoadingScreen = false
      disconnect(this.streamingCctvId)
    },
    clickList(arg) {
      console.log('클릭한 버튼')
      console.log(arg)
      if (arg === 'thumbnail') {
        this.thumbnailList = true
        this.playList = false
      } else {
        this.thumbnailList = false
        this.playList = true
      }
    },
    // 로딩화면 관련 함수 - 2020-02-28 김진희
    waitForLoading() {
      setTimeout(() => {
        this.loading = false
        loadingTime = 0
      }, (LOADING_GAGE_TIME + LOADING_TIME_INTERVAL) * 1000) // 최종 로딩시간 설정

      // loadCompleted
      setTimeout(() => {
        this.loadCompleted = true
        this.loadThumbnails()
      }, LOADING_CHECK_TIME * 1000)
      // 막대바로 변경
      this.addLoadingProgressBar() // 진행 시작
    },
    addLoadingProgressBar() {
      // id = loadingBar
      var ProgressBar = require('progressbar.js')
      var bar = new ProgressBar.Line('#loadingBar', {
        strokeWidth: 4,
        easing: 'easeInOut',
        duration: 1400,
        color: '#9EF048',
        trailColor: '#eee',
        trailWidth: 1,
        svgStyle: { width: '100%', height: '100%' },
        text: {
          style: {
            // Text color.
            // Default: same as stroke color (options.color)
            color: '#999',
            // position: 'absolute',
            textAlign: 'center',
            top: '20px',
            padding: 0,
            transform: null
          },
          autoStyleContainer: false
        },
        from: { color: '#FFEA82' },
        to: { color: '#ED6A5A' },
        step: (state, bar) => {
          bar.setText(Math.round(bar.value() * 100) + ' %')
        }
      })

      this.animateLoadingProgressBar(bar)
      // bar.animate(1.0) // Number from 0.0 to 1.0
    },
    animateLoadingProgressBar(bar) {
      setTimeout(() => {
        console.log('loadingTime: ' + loadingTime)
        bar.animate(loadingTime / LOADING_GAGE_TIME)
        loadingTime += LOADING_TIME_INTERVAL // 시간 경과
        if (this.loading) {
          this.animateLoadingProgressBar(bar) // 시간 경과 후 다시 확인
        }
      }, 1000.0 * LOADING_TIME_INTERVAL)
    },
    animateLoadingCircle() {
      setTimeout(() => {
        this.$refs.loadingCircle.updateProgress(
          loadingTime * (100.0 / LOADING_GAGE_TIME)
        )
        loadingTime += LOADING_TIME_INTERVAL // 시간 경과
        if (this.loading) {
          this.animateLoadingCircle() // 시간 경과 후 다시 확인
        }
      }, 1000.0 * LOADING_TIME_INTERVAL)
    },
    loading_progress(event, progress, stepValue) {
      // console.log(stepValue)
    },
    loading_progress_end(event) {
      // console.log('Circle progress end')
    }
  }
}
</script>

<style lang='less' scoped>
@import '../../../assets/mobile/cctv.less';

#loadingBar {
  margin-left: 5vw;
  margin-right: 5vw;
  margin-top: 35vh;
  overflow: visible;
}

body {
  overflow: hidden;
}

/* .el-container */
.mobile-content {
  min-height: 600px;
}

#footer {
  position: fixed;
  bottom: 0px;
}

.el-main {
  padding: 0px;
}

.main-box {
  padding: 0px;
}

.result_area .img {
  position: absolute;
  padding: 1.5px 10px;
  color: #fff;
  font-weight: bold;
  line-height: 1.5;
}
.title_area .img {
  float: right;
}

// 2020-12-07 이미지 썸네일 모드에서는 가로 회전 시 가로 한 줄에 4개 모두 표시
@media (orientation: landscape) {
  #loadingBar svg {
    height: 2vh;
  }

  .two_thumbnails {
    float: left;
    width: 50%;
    margin-left: 0px;
    margin-right: 0px;
  }

  .two_thumbnails img {
    width: 48.5%;
  }
}
</style>
